import firebaseApp from "./FirebaseConfig";
import { getFirestore } from "firebase/firestore";
import {
  getDocs,
  collection,
  query,
  where,
  doc,
  setDoc,
  updateDoc,
} from "firebase/firestore";

const db = getFirestore(firebaseApp);

const createDocument = async (collectionName, uid, name, email) => {
  const creation = await setDoc(doc(collection(db, collectionName)), {
    isAllowed: false,
    isSubmited: false,
    uid,
    isPremium: false,
    name,
    email,
    date: Date.now(),
    formData: [],
  });
  return creation;
};

const readDocuments = async ({ collectionName, queries }) => {
  let collectionRef = collection(db, collectionName);

  if (queries && queries.length > 0) {
    for (const queryObj of queries) {
      const { field, condition, value } = queryObj;
      collectionRef = query(collectionRef, where(field, condition, value));
    }
  }

  const querySnapshot = await getDocs(collectionRef);
  const documents = querySnapshot.docs.map((doc) => ({
    id: doc.id,
    ...doc.data(),
  }));
  return documents;
};

const updateDocument = (collectionName, id, document) => {
  const documentRef = doc(collection(db, collectionName), id);
  return updateDoc(documentRef, document);
};

const updateDocumentField = (collectionName, documentId, discussion) => {
  const docRef = doc(db, collectionName, documentId);
  return updateDoc(docRef, {
    formData: discussion,
  });
};
const updateDocumentFieldIsSubmitted = (collectionName, documentId) => {
  const docRef = doc(db, collectionName, documentId);
  return updateDoc(docRef, {
    isAllowed:true,
    isSubmited: true,
  });
};

const FirebaseFirestoreService = {
  createDocument,
  readDocuments,
  updateDocument,
  updateDocumentField,
  updateDocumentFieldIsSubmitted,
};

export default FirebaseFirestoreService;
